import CtrlWorkflowRoute from '@/modules/workflow/ctrl-workflow/routes'
import CtrlProcessosRoute from '@/modules/workflow/ctrl-processos/routes'
import CtrlTarefasRoute from '@/modules/workflow/ctrl-tarefas/routes'
import CtrlProvedoresRoute from '@/modules/workflow/ctrl-provedores/routes'
import CtrlFormulariosRoute from '@/modules/workflow/ctrl-formularios/routes'
import TicketsRoute from '@/modules/workflow/tickets/routes'
import fichaTecnicaWorkflowRoute from '@/modules/workflow/ficha-tecnica-workflow/routes'
import filasTarefas from '@/modules/workflow/filas-tarefas/routes'
import CtrlWorkflowRecuperacao from '@/modules/workflow/ctrl-workflow-recuperacao/routes'
import TarefaMobilidadeAbas from '@/modules/workflow/tarefas-mobilidades/routes'
import CtrlDesignacaoRoute from '@/modules/workflow/ctrl-designacao/routes'
import PcoEmailsQueueRoute from '@/modules/workflow/pco-emails-queue/routes'
import PcoWorkflowTempRoute from '@/modules/workflow/pco-workflow-temp/routes'
import CtrlProvedoresMultaRoute from '@/modules/workflow/ctrl-provedores-multa/routes'
import CtrlDisponibilidadeRoute from '@/modules/workflow/ctrl-disponibilidade/routes'
import CtrlTratativasRoute from '@/modules/workflow/ctrl-tratativas/routes'
import CtrlAnaliticosProvedorRoute from '@/modules/workflow/ctrl-analiticos-provedor/routes'
import BacklogRoute from '@/modules/workflow/backlog/routes'
import WorkflowFormsRoute from '@/modules/workflow/forms/routes'
import CtrlRegionaisRoute from '@/modules/workflow/ctrl-regionais/routes'
import GestaoEmailsAutomaticosRoute from '@/modules/workflow/gestao-emails-automaticos/routes'
import PesquisaRoute from '@/modules/workflow/pesquisa/routes'
import CtrlTipoServicoRoute from '@/modules/workflow/ctrl-tipo-servico/routes'
import CtrlStatusRoute from '@/modules/workflow/ctrl-status/routes'
import CtrlTipoSolicitacao from '@/modules/workflow/ctrl-tipo-solicitacao/routes'
import CtrlTecnicos from '@/modules/workflow/ctrl-tecnicos/routes'

const routes = [
  ...CtrlWorkflowRoute,
  ...CtrlProcessosRoute,
  ...CtrlTarefasRoute,
  ...CtrlProvedoresRoute,
  ...CtrlFormulariosRoute,
  ...BacklogRoute,
  ...TicketsRoute,
  ...fichaTecnicaWorkflowRoute,
  ...filasTarefas,
  ...CtrlWorkflowRecuperacao,
  ...TarefaMobilidadeAbas,
  ...CtrlDesignacaoRoute,
  ...CtrlProvedoresMultaRoute,
  ...CtrlDisponibilidadeRoute,
  ...CtrlTratativasRoute,
  ...PcoEmailsQueueRoute,
  ...PcoWorkflowTempRoute,
  ...CtrlAnaliticosProvedorRoute,
  ...WorkflowFormsRoute,
  ...CtrlRegionaisRoute,
  ...GestaoEmailsAutomaticosRoute,
  ...PesquisaRoute,
  ...CtrlTipoServicoRoute,
  ...CtrlStatusRoute,
  ...CtrlTipoSolicitacao,
  ...CtrlTecnicos,
]

export default routes
